import React from 'react';
import { Button, CircularProgress } from '@mui/material';
import { Refresh as RefreshIcon } from '@mui/icons-material';

/**
 * Reusable Refresh Button Component
 * 
 * @param {Object} props
 * @param {Function} props.onClick - Function to handle refresh action
 * @param {boolean} props.loading - Loading state to disable the button and show loading spinner/animation
 * @param {string} props.label - Button label (default: 'Refresh')
 * @param {string} props.variant - Button variant (default: 'outlined')
 * @param {string} props.size - Button size (default: 'small')
 * @param {Object} props.sx - Custom sx styles for the button
 */
const RefreshButton = ({ 
  onClick, 
  loading = false, 
  disabled = false,
  label = 'Refresh', 
  variant = 'outlined',
  size = 'small',
  sx = {} 
}) => {
  return (
    <Button
      variant={variant}
      size={size}
      startIcon={
        loading ? (
          <CircularProgress size={16} color="inherit" />
        ) : (
          <RefreshIcon />
        )
      }
      onClick={onClick}
      disabled={loading || disabled}
      sx={{
        textTransform: 'none',
        fontWeight: 600,
        borderRadius: 2,
        ...sx
      }}
    >
      {label}
    </Button>
  );
};

export default RefreshButton;
